module.exports = __webpack_public_path__ + "static/img/pro3_tab6.bc7911f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceFour/pro3_tab6.jpg
// module id = 8o4g
// module chunks = 171